import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

/**
 * `/admin/finance` — pathless layout for every Finance sub-surface.
 * Page-level navigation is owned by the AdminShell detail panel
 * (`FINANCE_SUBMENU` in `rail-config.tsx`), mirroring the Subscriptions
 * branch's layout/index/leaf-route split.
 */
export const Route = createFileRoute('/admin/finance')({
  component: FinanceLayout,
})

function FinanceLayout(): ReactElement {
  return <Outlet />
}
